<template>
  <div>
    <venue></venue>
    <br/>
    <EventImagesupload></EventImagesupload>
    

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
//import axios from "axios";
//import Eventbasicsetup from "../../../components/EventBasicsetup.vue";
import EventImagesupload from "../../../components/EventImagesupload.vue";
import venue from '../masters/venues.vue'
export default {
  components: { EventImagesupload,venue },
  data() {
    return {
      snackbar: false,
    };
  },
  mounted() {
    //console.log("HI");
    console.log(this.$store.state.eventInfo.EventName);
    this.$store.commit("setPageTitle", this.$store.state.eventInfo.EventName);

    this.Reload();
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },
  },
};
</script>

<style>
</style>